//#region types
import { MoreActionMenuItem } from "models/propTypes/menuPropTypes";
//#endregion
//#region components
import useSurveySnoozeAction from "./useSurveySnoozeAction";
import useSurveyForwardAction from "./useSurveyForwardAction";
//#endregion

function useSurveyQuickActions(id: string, markAsDone: (id: string) => void) {
  const { snoozeAction } = useSurveySnoozeAction(id, markAsDone);
  const { forwardAction } = useSurveyForwardAction(id, markAsDone);

  const quickActions: MoreActionMenuItem[] = [];
  quickActions.push(snoozeAction);
  quickActions.push(forwardAction);

  return quickActions;
}

export default useSurveyQuickActions;
